import type { EntityType } from '../types/api';
import { getEntityLabel } from '../utils/labels';

interface Props {
  summary: Partial<Record<EntityType, number>>;
  disabled: Set<EntityType>;
  onToggle: (type: EntityType, enabled: boolean) => void;
}

export function CategoryToggles({ summary, disabled, onToggle }: Props) {
  const entries = (Object.entries(summary) as [EntityType, number][])
    .sort(([a], [b]) => a.localeCompare(b));

  return (
    <div className="summary-grid">
      {entries.map(([type, count]) => {
        const enabled = !disabled.has(type);
        return (
          <label
            key={type}
            className={`summary-item type-${type}${enabled ? '' : ' disabled'}`}
          >
            <span>
              <input
                type="checkbox"
                checked={enabled}
                onChange={(e) => onToggle(type, e.target.checked)}
              />
              {getEntityLabel(type)}
            </span>
            <span className="count">{count}</span>
          </label>
        );
      })}
    </div>
  );
}
